<template>
  <div class="mt-4 mt-md-5 position-relative internet-modal__transitions--padding">
    <div class="d-flex justify-content-between align-items-center">
      <span>
        {{ I18n.t("artworks.starting_price_label")}}
      </span>
      <span class="price">
        {{ I18n.t("artworks.price", { price: formatPrice(internetAuction.artwork.startingPrice) }) }}
      </span>
    </div>
    <div
      v-if="internetAuction.artwork.estimationMin && internetAuction.artwork.estimationMax"
      class="d-flex justify-content-between align-items-center"
    >
      <span>
        {{ I18n.t("artworks.estimation_label") }}
      </span>
      <span class="price">
        {{ I18n.t("artworks.estimated_prices_with_currency",
          { price_min: formatPrice(internetAuction.artwork.estimationMin),
            price_max: formatPrice(internetAuction.artwork.estimationMax) }) }}
      </span>
    </div>
    <div
      v-if="internetAuction.artwork.droitDeSuite"
      class="d-flex justify-content-between align-items-center internet-modal__transitions--height"
    >
      <span>
        {{ I18n.t("artworks.additional_payments") }}
      </span>
      <span>
        {{ I18n.t("artworks.droit_de_suite") }}
      </span>
    </div>
    <transition name="fade">
      <div
        v-if="showCurrentLimit"
        class="position-absolute w-100 d-flex justify-content-between align-items-center"
      >
        <span>
          {{ I18n.t("internet_auctions.user_limit") }}
        </span>
        <span class="price">
          {{ currentLimit }}
        </span>
      </div>
    </transition>
  </div>
</template>

<script>
  import { formatNumber } from '@/shared/helpers';

  export default {
    name: 'ArtworkPriceDetails',
    props: {
      internetAuction: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        formatPrice: formatNumber,
      };
    },
    computed: {
      currentLimit() {
        return `${this.formatPrice(this.internetAuction.userLimit)} zł`;
      },
      showCurrentLimit() {
        return this.internetAuction.userLimit &&
               (this.internetAuction.userLimit > this.internetAuction.value);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/internet_auctions/components/modal/artwork_price_details.vue?04439bb0